import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@shabic/core';
import { ProfileComponent } from './profile.component';
import {
  ChangePasswordComponent,
  CompanyInfoComponent,
  ProfileInfoComponent,
  BankAccountComponent,
  ApiUserComponent,
  MarketingComponent,
  SupplierApiComponent
} from './components';
import { ReportSettingComponent } from './components/report-setting/report-setting.component';

const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ProfileInfoComponent,
      },
      {
        path: 'bank-account',
        component: BankAccountComponent,
      },
      {
        path: 'supplier-api',
        component: SupplierApiComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
      {
        path: 'company-info',
        component: CompanyInfoComponent,
      },
      {
        path: 'api-user',
        component: ApiUserComponent,
      },
      {
        path: 'marketing',
        component: MarketingComponent,
      },
      {
        path: 'report-setting',
        component: ReportSettingComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
